module.exports = __webpack_public_path__ + "img/AL12X1-2-EN.ea201d46.png";